// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".checkout-intro p[data-v-587dbcbb]{max-width:680px}.checkout-intro .voucher-protection[data-v-587dbcbb]{cursor:help;display:inline-flex;vertical-align:middle}.checkout-intro .info-sign[data-v-587dbcbb]{stroke:var(--body-color);fill:none;stroke-width:1.5px;font-size:18px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
